import { render, staticRenderFns } from "./SandwichIcon.vue?vue&type=template&id=ef1e339a&"
import script from "./SandwichIcon.vue?vue&type=script&lang=ts&"
export * from "./SandwichIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ef1e339a', component.options)
    } else {
      api.reload('ef1e339a', component.options)
    }
    module.hot.accept("./SandwichIcon.vue?vue&type=template&id=ef1e339a&", function () {
      api.rerender('ef1e339a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/SandwichIcon.vue"
export default component.exports